// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"225":"84572a04","856":"5e289adb"}[chunkId] + ".chunk.css";
};